export const DEFAULT_MANUAL_SEARCH = false
export const DEFAULT_INITIAL_SEARCH_TRACKED = false
export const DEFAULT_MANUAL_SEARCH_TRACKED = false
export const DEFAULT_NUM_RESULTS_TRACKED = false
export const DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING = {}
export const DEFAULT_DISABLE_EXTENDED_QUALIFIED_VIEW_TRACKING = {}
export const DEFAULT_DISABLE_USER_INTERACTION_TRACKING = {}

export default {
  manualSearch: DEFAULT_MANUAL_SEARCH,
  initialSearchTracked: DEFAULT_INITIAL_SEARCH_TRACKED,
  manualSearchTracked: DEFAULT_MANUAL_SEARCH_TRACKED,
  numResultsTracked: DEFAULT_NUM_RESULTS_TRACKED,
  disableQualifiedTracking: DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING,
  disableExtendedQualifiedTracking: DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING,
  disableUserInteractrionTracking: DEFAULT_DISABLE_USER_INTERACTION_TRACKING
}
